export default __webpack_public_path__ + "static/media/sierra-leone.4e9e25af.png";